import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AccountComponent, MyFavoritesComponent, AccountInformationComponent, InvoicesComponent, ProfileComponent, EmailDeliveryComponent } from './';

const accountRoutes: Routes = [
  {
    path: '',
    component: AccountComponent,
    children: [
      { path: '', component: MyFavoritesComponent },
      { path: 'favorites', component: MyFavoritesComponent },
      { path: 'information', component: AccountInformationComponent },
      { path: 'invoices', component: InvoicesComponent },
      { path: 'profile', component: ProfileComponent },
      { path: 'data-by-email', component: EmailDeliveryComponent }
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(accountRoutes)
  ],
  exports: [
    RouterModule
  ]
})

export class AccountRoutingModule { }



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/account/account-routing.module.ts